const moment = require('moment')

module.exports = {
    methods: {
        // ponytail: expose moment to all templates via the global mixin,
        // since `moment(...)` in a template resolves to `this.moment`.
        moment,

        /**
         * Translate the given key.
         */
        __(key, replace = {}) {
            var translation = this.$page.props.language[key]
                ? this.$page.props.language[key]
                : key

            Object.keys(replace).forEach(function (key) {
                translation = translation.replace(':' + key, replace[key])
            });

            return translation
        },

        /**
         * Format a name to title case, e.g. "tantan" / "TANTAN" -> "Tantan".
         */
        properName(value) {
            if (!value) return value

            return value
                .toLowerCase()
                .replace(/(^|\s)\S/g, (char) => char.toUpperCase())
        },
    },
}
